import { useState } from 'react'
import Snippet from '../../../components/Snippet/Snippet'
import {
    group,
    groupRounded,
    groupUnderline,
    inline,
    inlineRow,
    labelWrongRightRounded,
    labelWrongLeftRounded,
    rounded,
    row,
    text,
    underline,
    labelRoundedAfter,
    labelRoundedBefore,
    labelUnderlineBefore,
    labelUnderlineAfter,
    labelBefore,
    labelAfter
} from '../../../assets/code-snippets/form/snip'
import FormItemSwitcher from './FormItemSwitcher'

const Form = () => {

    const [formItem, setFormItem] = useState({
        type: 'text',
        size: 'md',
        error: false
    })
    const [errorItem, setErrorItem] = useState({
        type: 'text',
        size: 'md',
        error: 'success'
    })
    let snippet = FormItemSwitcher(formItem)
    let styleSnippet = FormItemSwitcher(formItem)
    let errorSnippet = FormItemSwitcher(errorItem)

    const helperType = (e) => {
        setFormItem(prev => ({ ...prev, type: e }))
    }
    const helperSize = (e) => {
        setFormItem(prev => ({ ...prev, size: e }))
    }

    const helperErrorFieldType = (e) => {
        setErrorItem(prev => ({ ...prev, type: e }))
    }
    const helperErrorType = (e) => {
        setErrorItem(prev => ({ ...prev, error: e }))
    }

    return <div className="row">
        <div className="col md-I sticky order-last menu-column">
            <div className="side-menu">
                <p className="text md bold danger">`POKE-CSS`</p>
                <p className="text xs">on this page</p>
                <ul className="primary-list">
                    <li><a href="#form-item">-Form item-</a></li>
                    <li><a href="#form-style">-Form style-</a></li>
                    <li><a href="#form-validation">-Form validation-</a></li>
                    <li><a href="#form-group">-Form group-</a></li>
                    <li><a href="#form-input-label">-Form input label-</a></li>
                </ul>
            </div>
        </div>
        <div className="col md-V content-column">

            {/* INTRO */}
            <div className="container fluid py-2" id="intro">
                <div className="container fluid">
                    <p className="text xl"><a href="#intro" className="link">&#128279;</a> Forms in POKE-CSS </p>
                    <p className="text md">
                        Forms inputs are group one by one into a parent block which sets the style of the
                            <code>input</code> and the <code>label</code>, also the <code>error-section</code> is framed
                            into this. The different sizes are applied by different <code>CSS</code> class such as:
                            <code>sm</code>, <code>md</code>,
                            <code>lg</code> and <code>xl</code> each one of these applies different paddings and font
                            sizes to its child elements.
                        </p>
                </div>
            </div>
            {/* INTRO ENDS HERE */}

            {/* FORM ITEM */}
            <div className="container fluid py-2" id="form-item">
                <div className="container fluid">
                    <p className="text xl"><a href="#form-item" className="link">&#128279;</a> <code>form-item</code>
                    </p>
                    <p className="text md">
                        Form item is a parent element which wraps the input's label and input itself in order to
                        apply certain style over these, in fact form item is very easy to construct
                        </p>
                    <p className="text md">Steps:</p>
                    <ol>
                        <li>create a div with class <code>.form-item</code></li>
                        <li>create a label element inside of the element above</li>
                        <li>also create the input and place it under the label</li>
                    </ol>
                </div>

                <div className="spacer md"></div>

                <div className="row align-items-center">
                    <div className="col md-III">

                        <p className="text md">A simple example:</p>
                        <div className="container sm">
                            <Snippet code={text} language='html' />
                        </div>
                    </div>
                    <div className="col md-III">
                        <div className="container sm">
                            <div className="form-item md">
                                <label>label-content</label>
                                <input type="text" placeholder="text" />
                            </div>
                        </div>
                    </div>
                </div>

                <p className="text xl">Templates</p>
                <div className="row align-items-center">
                    <div className="col md-III">
                        <div className="form-group form-row md align-items-end">
                            <div className="form-item">
                                <label>Select form item</label>
                                <select onChange={(e) => helperType(e.target.value)}>
                                    <option value="text" defaultValue>text</option>
                                    <option value="password">password</option>
                                    <option value="email">email</option>
                                    <option value="date">date</option>
                                    <option value="datetime-local">datetime-local</option>
                                    <option value="time">time</option>
                                    <option value="week">week</option>
                                    <option value="month">month</option>
                                    <option value="file">file</option>
                                    <option value="number">number</option>
                                    <option value="search">search</option>
                                    <option value="tel">tel</option>
                                    <option value="url">url</option>
                                    <option value="textarea">textarea</option>
                                    <option value="select">select</option>
                                    <option value="range">range</option>
                                    <option value="checkbox">checkbox</option>
                                    <option value="radio">radio</option>
                                    <option value="color">color</option>
                                </select>
                            </div>
                            <div className="form-item">
                                <label>Select item size</label>
                                <select onChange={(e) => helperSize(e.target.value)}>
                                    <option value="md">md</option>
                                    <option value="sm">sm</option>
                                    <option value="lg">lg</option>
                                    <option value="xl">xl</option>
                                </select>
                            </div>
                        </div>


                    </div>
                    <div className="col md-III">

                        <div id="form-item-element" className="container sm px-5">

                            {<div dangerouslySetInnerHTML={{ __html: snippet }}></div>}

                        </div>

                        <Snippet code={snippet} language='html' />
                    </div>
                </div>


            </div>
            {/* FORM ITEM ENDS HERE */}

            {/* FORM STYLING */}
            <div className="container fluid py-2" id="form-style">
                <div className="container fluid">
                    <p className="text xl"><a href="#form-style" className="link">&#128279;</a> <code>form-item</code> styling</p>
                    <p className="text md"> Form styling comes as 3 categories: regular, rounded & underline. </p>

                    <p className="text md"> Regular is the basic style which is applied when creating a form item as seen above.</p>
                    <Snippet code={text} language='html' />

                    <p className="text md"> Rounded will be applied if we add on parent div element <code>form-item</code> the class <code>rounded</code></p>
                    <Snippet code={rounded} language='html' />

                    <p className="text md"> Underline style is applied when added on the parent class <code>underline</code> same as <code>rounded</code> above</p>
                    <Snippet code={underline} language='html' />
                </div>

                <div className="spacer md"></div>


                <p className="text xl">Templates</p>
                <div className="row align-items-center">
                    <div className="col md-III">

                        <div className="form-group form-row md align-items-end" id="form-item-selector-style">
                            <div className="form-item">
                                <label>Select type</label>
                                <select onChange={(e) => helperType(e.target.value)}>
                                    <option value="text">text</option>
                                    <option value="password">password</option>
                                    <option value="email">email</option>
                                    <option value="date">date</option>
                                    <option value="datetime-local">datetime-local</option>
                                    <option value="time">time</option>
                                    <option value="week">week</option>
                                    <option value="month">month</option>
                                    <option value="file">file</option>
                                    <option value="number">number</option>
                                    <option value="search">search</option>
                                    <option value="tel">tel</option>
                                    <option value="url">url</option>
                                    <option value="textarea">textarea</option>
                                    <option value="select">select</option>
                                    <option value="color">color</option>
                                </select>
                            </div>
                            <div className="form-item">
                                <label>Select item size & style</label>
                                <select onChange={(e) => helperSize(e.target.value)}>
                                    <option value="md">md</option>
                                    <option value="sm">sm</option>
                                    <option value="lg">lg</option>
                                    <option value="xl">xl</option>

                                    <option value="sm form-underline">sm form-underline</option>
                                    <option value="md form-underline">md form-underline</option>
                                    <option value="lg form-underline">lg form-underline</option>
                                    <option value="xl form-underline">xl form-underline</option>

                                    <option value="sm form-rounded">sm form-rounded</option>
                                    <option value="md form-rounded">md form-rounded</option>
                                    <option value="lg form-rounded">lg form-rounded</option>
                                    <option value="xl form-rounded">xl form-rounded</option>
                                </select>
                            </div>
                        </div>


                    </div>
                    <div className="col md-III">

                        <div className="container sm px-5">
                            {<div dangerouslySetInnerHTML={{ __html: styleSnippet }}></div>}
                        </div>
                        <Snippet code={styleSnippet} language='html' />
                    </div>
                </div>


            </div>
            {/* FORM STYLING ENDS HERE */}

            {/* VALIDATION */}
            <div className="container fluid py-2" id="form-validation">
                <div className="container fluid">
                    <p className="text xl"><a href="#form-validation" className="link">&#128279;</a> <code>form-item</code> validation</p>
                    <p className="text md"> Form validation works in 2 ways as: success or invalid </p>

                    <div className="form-group form-row lg">
                        <div className="form-item success">
                            <label>label</label>
                            <input type="text" />
                            <div className="error-section">
                                <span>error</span>
                            </div>
                            <div className="success-section">
                                <span>success</span>
                            </div>
                        </div>
                        <div className="form-item invalid">
                            <label>label</label>
                            <input type="text" />
                            <div className="error-section">
                                <span>error</span>
                            </div>
                            <div className="success-section">
                                <span>success</span>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="spacer md"></div>

                <p className="text xl">Templates</p>
                <div className="row align-items-center">
                    <div className="col md-III">

                        <div className="form-group form-row md align-items-end" id="form-item-selector-validation">
                            <div className="form-item">
                                <label>Select form item</label>
                                <select onChange={(e) => helperErrorFieldType(e.target.value)}>
                                    <option value="text">text</option>
                                    <option value="password">password</option>
                                    <option value="email">email</option>
                                    <option value="date">date</option>
                                    <option value="datetime-local">datetime-local</option>
                                    <option value="time">time</option>
                                    <option value="week">week</option>
                                    <option value="month">month</option>
                                    <option value="file">file</option>
                                    <option value="number">number</option>
                                    <option value="search">search</option>
                                    <option value="tel">tel</option>
                                    <option value="url">url</option>
                                    <option value="textarea">textarea</option>
                                    <option value="select">select</option>
                                    <option value="range">range</option>
                                    <option value="checkbox">checkbox</option>
                                    <option value="radio">radio</option>
                                    <option value="color">color</option>
                                </select>
                            </div>
                            <div className="form-item">
                                <label>Select item size & validation</label>
                                <select onChange={(e) => helperErrorType(e.target.value)}>
                                    <option value="success">success</option>
                                    <option value="invalid">invalid</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col md-III">
                        <div id="form-item-element-validation" className="container sm px-5">
                            {<div dangerouslySetInnerHTML={{ __html: errorSnippet }}></div>}
                        </div>
                        <Snippet code={errorSnippet} language='html' />
                    </div>
                </div>
            </div>
            {/* VALIDATION ENDS HERE */}

            {/* GROUP */}
            <div className="container fluid py-2" id="form-group">
                <div className="container fluid">
                    <p className="text xl"><a href="#form-group" className="link">&#128279;</a> <code>form-group</code></p>
                    <p className="text md"> As name defines it <code>form-group</code> class will group form items togheter and also applies certain layout positioning and style on these. </p>
                </div>

                <div className="spacer md"></div>

                <p className="text xl">Templates layout</p>
                <div className="row align-items-center shadow-sm border-dark">
                    <div className="col md-III p-1">
                        <div className="form-group md">
                            <div className="form-item">
                                <label>text md</label>
                                <input type="text" />
                            </div>
                            <div className="form-item">
                                <label>text md</label>
                                <input type="text" />
                            </div>
                        </div>
                        <Snippet code={group} language='html' />

                        <div className="form-group md form-inline form-row">
                            <div className="form-item">
                                <label>text md</label>
                                <input type="text" />
                            </div>
                            <div className="form-item">
                                <label>text md</label>
                                <input type="text" />
                            </div>
                        </div>
                        <Snippet code={inlineRow} language='html' />

                    </div>
                    <div className="col md-III p-1">
                        <div className="form-group md form-row">
                            <div className="form-item">
                                <label>text md</label>
                                <input type="text" />
                            </div>
                            <div className="form-item">
                                <label>text md</label>
                                <input type="text" />
                            </div>
                        </div>
                        <Snippet code={row} language='html' />

                        <div className="form-group md form-inline">
                            <div className="form-item">
                                <label>text md</label>
                                <input type="text" />
                            </div>
                            <div className="form-item">
                                <label>text md</label>
                                <input type="text" />
                            </div>
                        </div>
                        <Snippet code={inline} language='html' />
                    </div>
                </div>

                <div className="hr lg dotted primary wide"></div>

                <p className="text xl">Templates style</p>
                <div className="row align-items-center shadow-sm border-dark">

                    <div className="col md-III p-1">
                        <p className="text lg info">Underline</p>
                        <div className="form-group md form-underline">
                            <div className="form-item">
                                <label>text md</label>
                                <input type="text" />
                            </div>
                            <div className="form-item">
                                <label>text md</label>
                                <input type="text" />
                            </div>
                        </div>
                        <Snippet code={groupUnderline} language='html' />
                    </div>
                    <div className="col md-III p-1">
                        <p className="text lg info">Rounded</p>
                        <div className="form-group md form-rounded">
                            <div className="form-item">
                                <label>text md</label>
                                <input type="text" />
                            </div>
                            <div className="form-item">
                                <label>text md</label>
                                <input type="text" />
                            </div>
                        </div>
                        <Snippet code={groupRounded} language='html' />
                    </div>
                </div>
            </div>
            {/* GROUP ENDS HERE */}

            {/* INPUT LABEL */}
            <div className="container fluid py-2" id="form-input-label">
                <div className="container fluid">
                    <p className="text xl"><a href="#form-input-label" className="link">&#128279;</a> Form input label</p>
                    <p className="text md">Input label is the parent element of <code>input</code> element, once created will style a <code>span</code> by setting its padding and font-size according to one of the prefered sizes: sm, md, lg & xl.</p>
                </div>
                <div className="spacer md"></div>
                <div className="row align-items-center">
                    <div className="col md-III">
                        <div className="form-item lg">
                            <div className="input-label">
                                <span>@</span>
                                <input type="text" />
                            </div>
                        </div>
                        <Snippet code={labelBefore} language='html' />
                        <div className="spacer sm"></div>
                        <div className="form-item lg">
                            <div className="input-label">
                                <input type="text" />
                                <span>@</span>
                            </div>
                        </div>
                        <Snippet code={labelAfter} language='html' />
                    </div>
                    <div className="col md-III">
                        <div className="form-item lg form-underline">
                            <div className="input-label">
                                <span>@</span>
                                <input type="text" />
                            </div>
                        </div>
                        <Snippet code={labelUnderlineBefore} language='html' />
                        <div className="spacer sm"></div>
                        <div className="form-item lg form-underline">
                            <div className="input-label">
                                <input type="text" />
                                <span>@</span>
                            </div>
                        </div>
                        <Snippet code={labelUnderlineAfter} language='html' />
                    </div>
                </div>
                <div className="hr dotted lg medium primary"></div>
                <div className="container fluid">
                    <p className="text md"> Input label also comes in addition with 2 classes, such as: <code>before</code> & <code>after</code>, these classes are only useful if <code>form-rounded</code> class is applied to our <code>form-item</code>. </p>
                </div>

                <div className="row align-items-center">
                    <div className="col md-III">

                        <div className="form-item lg form-rounded">
                            <div className="input-label before">
                                <span>@</span>
                                <input type="text" />
                            </div>
                        </div>
                        <Snippet code={labelRoundedBefore} language='html' />
                    </div>
                    <div className="col md-III">
                        <div className="form-item lg form-rounded">
                            <div className="input-label after">
                                <input type="text" />
                                <span>@</span>
                            </div>
                        </div>
                        <Snippet code={labelRoundedAfter} language='html' />
                    </div>
                </div>

                <div className="container fluid">
                    <p className="text md"> If <code>before</code> or <code>after</code> class is not applied in addition to <code>input-label</code> class when using <code>form-rounded</code> will apply <code>border-radius</code> property only to  the <code>input</code> element and not to  <code>input-label</code>. </p>
                </div>

                <div className="space-between">
                    <span className="badge xl danger gradient">WRONG</span>
                    <span className="badge xl danger gradient">WRONG</span>
                    <span className="badge xl danger gradient">WRONG</span>
                </div>

                <Snippet code={labelWrongRightRounded} language='html' />
                <Snippet code={labelWrongLeftRounded} language='html' />
                <div className="form-item lg form-rounded">
                    <div className="input-label">
                        <input type="text" />
                        <span>@</span>
                    </div>
                </div>
                <div className="form-item lg form-rounded">
                    <div className="input-label">
                        <span>@</span>
                        <input type="text" />
                    </div>
                </div>

                <div className="space-between">
                    <span className="badge xl danger gradient">WRONG</span>
                    <span className="badge xl danger gradient">WRONG</span>
                    <span className="badge xl danger gradient">WRONG</span>
                </div>
            </div>
            {/* INPUT LABEL ENDS HERE */}

        </div>
    </div>

}

export default Form